import { FaGift, FaHandshake, FaMapMarkerAlt, FaPaintBrush } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaGift />, // Gift icon
    title: 'Custom Packages',
    description: 'Explore customized wedding packages designed to suit your unique preferences.',
  },
  {
    id: 2,
    icon: <FaHandshake />, // Handshake icon
    title: 'Trusted Vendors',
    description: 'Connect with a curated network of reliable and professional vendors.',
  },
  {
    id: 3,
    icon: <FaMapMarkerAlt />, // Map marker icon
    title: 'Exclusive Venues',
    description: 'Discover and book the perfect venue from our selection of breathtaking locations.',
  },
  {
    id: 4,
    icon: <FaPaintBrush />, // Paint brush icon
    title: 'Design & Décor',
    description: 'Bring your dream wedding to life with our sophisticated design and décor services.',
  },
];

export default features;